import { render, staticRenderFns } from "./CertificateIssue.vue?vue&type=template&id=10ec9308&scoped=true&"
import script from "./CertificateIssue.vue?vue&type=script&lang=js&"
export * from "./CertificateIssue.vue?vue&type=script&lang=js&"
import style0 from "./CertificateIssue.vue?vue&type=style&index=0&id=10ec9308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec9308",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VCol,VContainer,VFileInput,VRow,VTextField})
